import TeacherApplicationUploadRequestedDocuments from './TeacherApplicationUploadRequestedDocuments.component';

export default TeacherApplicationUploadRequestedDocuments;